import { BaseModel } from './base.model';
import { PrizeModel } from './prize.model';

export enum PrizeRequestStatus {
  PENDING = 'Pendiente',
  APPROVED = 'Aprobada',
  REJECTED = 'Rechazada',
  DELIVERED = 'Entregada'
}

export class PrizeRequestModel extends BaseModel {
  request_number: string;
  user_id: string;
  prize_id: string;
  prize?: PrizeModel;
  points_redeemed: number;
  status: PrizeRequestStatus;

  full_name: string;
  delivery_address: string;
  city: string;
  phone: string;
  email: string;
  additional_notes?: string;
  terms_accepted: boolean;

  rejection_reason?: string;
  admin_comments?: string;
  approved_by?: string;
  approved_at?: Date;
  rejected_by?: string;
  rejected_at?: Date;
  delivered_at?: Date;

  constructor(data?: any) {
    super(data);
    this.request_number = data?.request_number || '';
    this.user_id = data?.user_id || '';
    this.prize_id = data?.prize_id || '';
    this.prize = data?.prize ? new PrizeModel(data.prize) : undefined;
    this.points_redeemed = data?.points_redeemed || 0;
    this.status = data?.status || PrizeRequestStatus.PENDING;

    this.full_name = data?.full_name || '';
    this.delivery_address = data?.delivery_address || '';
    this.city = data?.city || '';
    this.phone = data?.phone || '';
    this.email = data?.email || '';
    this.additional_notes = data?.additional_notes;
    this.terms_accepted = data?.terms_accepted || false;

    this.rejection_reason = data?.rejection_reason;
    this.admin_comments = data?.admin_comments;
    this.approved_by = data?.approved_by;
    this.approved_at = data?.approved_at ? new Date(data.approved_at) : undefined;
    this.rejected_by = data?.rejected_by;
    this.rejected_at = data?.rejected_at ? new Date(data.rejected_at) : undefined;
    this.delivered_at = data?.delivered_at ? new Date(data.delivered_at) : undefined;
  }
}
